module.exports = ['$scope', function($scope) {
	$scope.feedback = {};

	setTimeout(function() {
		$scope.feedback.hideFeedback();
	}, 300);

	if ($scope.stopEditSvcError.svcFailed == true) {
		setTimeout(function(){
			$scope.feedback.showFeedback($scope.stopEditSvcError.errorMsg, 'failure');
		}, 500);
	}
}];

